module.exports = __webpack_public_path__ + "img/image-4.ed14de92.jpg";